import React from 'react';
import { ChevronRight, Users, Zap, Award } from "lucide-react";
import '../../styles/cmyuva.css';
import heroImage from "../../assets/images/png/cmyuvahero-image2.png"

const CmYuvaHero = ({setFormActive}) => {
  const handleEnquireNow = ()=>{
    setFormActive(true);
  }

  return (
    <section className="cmyuva_hero_bg">
  {/* Decorative Background Orb */}
  <div className="hero_glow_orb"></div>

  <div className="container position-relative z-1">
    
    {/* Title Section */}
    <div className="mb-4">
      <h1
        data-aos="fade-up"
        data-aos-offset="120"
        className="ff_s text-center fs_55 mb-0 font-extrabold hero_main_heading"
        style={{ color: "#f8fafc" }}
      >
        HKI MEDIA X <span className="clr_theme">CM YUVA</span>
      </h1>
    </div>

    {/* Main Content Row */}
    {/* Added align-items-center for vertical centering */}
    <div className="row align-items-center"> 
      
      {/* LEFT: TEXT CONTENT (5 Columns on Medium+, 12 on Small) */}
      <div 
        className="col-12 col-md-5 pt-3 pt-md-0 text-center text-md-start" 
        style={{ zIndex: 4, position: "relative" }} 
        data-aos="fade-right"
      >
        <h1 className="cmyuva_hero_title">
          <span className="d-block">OPEN YOUR</span>
          <span className="d-block">HKI DIGITAL MEDIA</span>
          <span className="d-block">STUDIO FRANCHISE</span>
        </h1>
        
        <p className="cmyuva_hero_description mb-4">
          Own a scalable, next-generation media studio operating across skilling, advertising, entertainment, events, and AR/VR innovation.
        </p>

        {/* Action Button */}
        <div className="d-flex justify-content-start justify-content-md-start">
          <button onClick={handleEnquireNow} className="cmyuva_btn_primary text-start btn-lg pulse-button">
            Check Eligibility <ChevronRight size={22} className="ms-2" />
          </button>
        </div>
      </div>

      {/* RIGHT: HERO IMAGE (7 Columns on Medium+, 12 on Small) */}
      <div 
        className="col-12 col-md-7  mt-4 mt-md-0 text-center" 
        style={{ zIndex: 5, position: "relative" }}
      >
        {/* Added img-fluid for responsiveness */}
        <img 
          src={heroImage} 
          className="cmyuva_hero_image floating-img img-fluid" 
          alt="cm yuva hero image" 
        />
      </div>
    </div>

    {/* Scroll Indicator */}
    <div className="scroll_indicator d-none d-md-flex"> {/* Optional: Hide on mobile if space is tight */}
      <div className="scroll_mouse">
        <div className="scroll_wheel"></div>
      </div>
      <small className="mt-3" style={{ color: "rgba(248, 250, 252, 0.55)" }}>Scroll Down</small>
    </div>
  </div>
</section>
  );
}

export default CmYuvaHero;
